export default function ArticlePage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>文章页面建设中...</p>
    </div>
  );
}